import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as Data from "@/data";
import * as Helpers from "../../helpers";
export default {
  props: {
    propertyId: {},
    latest: {
      default: false
    }
  },
  data: function data() {
    var me = this;
    return {
      addRowDialog: false,
      selectedProject: null,
      resyndicationTypeOptions: [],
      columns: [{
        name: "OldProject",
        label: "Old Project",
        field: function field(row) {
          return row.oldProject.propertyName;
        },
        sortable: true,
        link: true,
        align: "left",
        onClick: function onClick(row) {
          me.$router.push({
            path: "/editproject/".concat(row.oldProject.propertyId)
          });
          me.hide();
        }
      }, {
        name: "OldPropjectNumber",
        label: "Old Project Number",
        field: function field(row) {
          return row.oldProject.mhdcNumber != null && row.oldProject.mhdcNumber.length > 0 ? row.oldProject.mhdcNumber : row.oldProject.lihtc;
        },
        sortable: true,
        align: "left"
      }, {
        name: "NewProject",
        label: "New Project",
        field: function field(row) {
          return row.newProject.propertyName;
        },
        sortable: true,
        link: true,
        align: "left",
        onClick: function onClick(row) {
          me.$router.push({
            path: "/editproject/".concat(row.newProject.propertyId)
          });
          me.hide();
        }
      }, {
        name: "NewPropjectNumber",
        label: "New Project Number",
        field: function field(row) {
          return row.newProject.mhdcNumber != null ? row.newProject.mhdcNumber != "" ? row.newProject.mhdcNumber : row.newProject.lihtc : row.newProject.lihtc;
        },
        sortable: true,
        align: "left"
      }, {
        name: "Type",
        label: "Type",
        field: function field(row) {
          return row.resyndicationType;
        },
        sortable: true,
        align: "left"
      }, {
        name: "resyndicatedDate",
        label: "Resyndicated Date",
        field: function field(row) {
          return Helpers.DateHelper.getFriendlyDateAllowNull(row.resyndicatedDate);
        },
        sortable: true,
        align: "left",
        sort: function sort(a, b) {
          return new Date(a) - new Date(b);
        }
      }],
      resyndicationData: []
    };
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.propertyId) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return Data.Resyndication.GetResyndicationHistoryByProperty(this.propertyId, this.latest);

              case 3:
                this.resyndicationData = _context.sent.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }(),
    GoToEditProject: function GoToEditProject(projectId) {
      me.$router.push({
        path: "/editproject/" + projectId
      });
    },
    show: function show() {
      this.$refs.dialog.show();
    },
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide: function onDialogHide() {
      this.$emit("hide");
    }
  },
  watch: {
    propertyId: function propertyId() {
      this.load();
    }
  }
};